// extracted by mini-css-extract-plugin
module.exports = {"steps":"styles_steps__ArI6X","stepIndicator":"styles_stepIndicator__Xt7iH","stepIndicatorDot":"styles_stepIndicatorDot__5M8aR","step":"styles_step__3988S"};